import { Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full',
  },
  {
    path: 'app',
    loadChildren: () => import('../app/app.routing').then(m => m.AppRoutes),
  },
  {
    path: 'auth',
    loadChildren: () => import('../authentication/authentication.routing').then(m => m.AuthenticationRoutes),
  },
  { path: '**', redirectTo: 'auth', pathMatch: 'full' }
];

export const CoreRoutes = routes;

